/**
 * Canonical / og:url sans query ni hash (UTM, tracking).
 */

/** Normalise pathname : racine avec slash, sinon sans slash final. */
const normalizePathname = (pathname: string): string => {
  if (!pathname || pathname === '/') {
    return '/';
  }
  return pathname.replace(/\/+$/, '') || '/';
};

/**
 * URL absolue origin + pathname uniquement.
 * @example toCleanCanonicalUrl('https://rakb.ma/cars/u?utm_source=fb') → 'https://rakb.ma/cars/u'
 */
export const toCleanCanonicalUrl = (href: string, fallbackOrigin = 'https://rakb.ma'): string => {
  const origin = fallbackOrigin.replace(/\/$/, '');

  if (!href?.trim()) {
    return `${origin}/`;
  }

  try {
    if (href.startsWith('http://') || href.startsWith('https://')) {
      const u = new URL(href);
      const path = normalizePathname(u.pathname);
      return path === '/' ? `${u.origin}/` : `${u.origin}${path}`;
    }

    const resolved = new URL(href.startsWith('/') ? href : `/${href}`, `${origin}/`);
    const path = normalizePathname(resolved.pathname);
    return path === '/' ? `${origin}/` : `${origin}${path}`;
  } catch {
    return `${origin}/`;
  }
};
